module.exports = __webpack_public_path__ + "img/fybx.7ef1a8c9.png";